import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { If } from "../../Generic/If";
import { PendingConfirmationVisitDates } from "./PendingConfirmationVisitDates/PendingConfirmationVisitDates";
import {
  Slide,
  SlideAppListContainer,
  SlideHeader,
  SlideProps,
  SlideStepLabel,
  SlideTitle,
} from "./Slide";

export const Slide1VisitDates = (props: SlideProps) => (
  <Slide>
    <SlideHeader>
      <If condition={props.showSteps}>
        <SlideStepLabel {...props} />
      </If>
      <SlideTitle>{translate(STRINGS.VISIT_DATES)}</SlideTitle>
    </SlideHeader>
    <SlideAppListContainer>
      <PendingConfirmationVisitDates visit={props.visit} />
    </SlideAppListContainer>
  </Slide>
);
